<script>
    /*
    	ReferralSuccessScreen.svelte

        Shows after the referral has been submitted to the server successfully.
    */

    import { onMount } from 'svelte';
    import { pop } from 'svelte-spa-router';
    import { scale, fade } from 'svelte/transition';
	import { signIn } from '../../common/auth.js';
    import { getIsPreferredPartner } from "../../common/utils.js";
    import { push } from 'svelte-spa-router';
    import {SERVICE_NAME} from "../../common/constants";

    // TCARE components

    // SMUI components

    const SVG_MOLECULAR_PATH = '/img/molecular_ruby.svg';
    const SVG_HUG_PATH = '/img/illustration_hug.png';

    // REMOVE THIS FAKE SCREEN SHOT!!!
    const IMG_SIMILAR_PATH = '/img/similar_services.png';

    $: isPreferredPartner = getIsPreferredPartner(serviceData);

    export let serviceData;             // the masterService API data

    onMount(() => {
    })

    const _onMyReferralsClick = () => {
        push('/my-resources')
    }

</script>

<style>
    .success-screen {
        color: var(--tcui-primary);
    }

    .success-screen .message-box {
        margin-top: -20px;
        max-width: 320px;
        padding: 35px 70px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: var(--tcui-ruby-light);
        border-radius: 30px;
    }

    .success-screen .buttons-row {
        margin-top: 20px;
        justify-content: center;
    }

    .success-screen .small {
        text-align: center;
        font-size: 13px;
    }

    .connected-svg {
        margin-left: 25px;
        margin-top: -55px;
    }

    .connected-msg {
        font-size: 32px;
        font-weight: 700;
        margin-top: -40px;
    }

    .service-name {
        margin-top: 5px;
        text-align: center;
        font-size: 18px;
    }

    .hug-svg {
        margin-top: -160px;
        margin-left: 500px;
    }

    .success-screen button {
        width: 175px;
        height: 35px;
        margin: 0px 10px;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 1px;
    }

    .button-clear {
        color: var(--tcui-primary);
        background-color: white;
        border-radius: 16px;
        border: 1px solid #E9E5EA;
    }

    .button-clear:hover {
        background-color: var(--tcui-aqua);
    }

    .button-aqua {
        color: white;
        background-color: var(--tcui-aqua);
        border-radius: 16px;
        border: none;        
    }

    .button-aqua:hover {
        background-color: var(--tcui-secondary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="success-screen" in:fade="{{ duration: 250 }}">
    {#if isPreferredPartner}
        <div class="flex-center">
            <div class="message-box" in:scale="{{ duration: 750, opacity: 0, start: 0.8, delay: 250 }}">
                <img class="connected-svg" src={SVG_MOLECULAR_PATH} alt={"SVG Design"} draggable="false" >
                <div class="connected-msg large">You've Connected</div>
                <div class="service-name">{serviceData['service-name']}</div>
                <div class="h-10"></div>
                <div class="small">
                    We will send this service your information and update you in “My Resources”
                    or you will be contacted directly from the service shortly.         
                </div>
            </div>
        </div>
    {:else}
        <!-- non-partner services -->
        <div class="flex-center">
            <div class="message-box" in:scale="{{ duration: 750, opacity: 0, start: 0.8, delay: 250 }}">
                <img class="connected-svg" src={SVG_MOLECULAR_PATH} alt={"SVG Design"} draggable="false" >
                <div class="connected-msg large">Resource Saved</div>
                <div class="service-name">{serviceData['service-name']}</div>
                <div class="h-10"></div>
                <div class="small">
                    This service can be accessed within “My Resources”. Your information will not be sent to the service,
                    please contact them directly for help.     
                </div>
            </div>
        </div>
    {/if}
    <div class="flex-center">
        <img class="hug-svg" src={SVG_HUG_PATH} alt={'Hugging'} in:scale="{{ duration: 750, opacity: 0, start: 0.8, delay: 250 }}" >
    </div>

    <div class="flex-row buttons-row">
        <button class="button-clear" on:click={() => pop()}>
            Return to Search
        </button>
        <button class="button-aqua" on:click={_onMyReferralsClick}>
            My Referrals
        </button>
        <!-- <button class="button-aqua">Attach to Care Plan</button> -->
    </div>

    <!--
    <div class="flex-center">
        <img class="fake-screenshot" src={IMG_SIMILAR_PATH} alt={"Similar Services"} draggable="false" >
    </div>
    -->
</div>